<template>
	<div>
	  <b-modal ref="modal-confirmation" id="modal-confirmation" hide-footer>
	    <div class="pr-3 pl-2 text-center">
	    	<img :src="`${publicPath}/img/rcp/material-symbols_check-circle.png`" class="mb-1">
	    	<div class="fz-18 fw-700 mb-4">{{message}}</div>
	    	<button type="button" class="btn btn-primary pr-5 pl-5 text-white" @click="closeModal">OK</button>
	    </div>
	  </b-modal>
	</div>
</template>

<script>
	
	import Vue from 'vue'
	import Auth from "@/services/Auth";

	export default {
    	name: "popup-confirmation",
	    data() {
	      return {
			publicPath  : process.env.BASE_URL!='/'?process.env.BASE_URL:'',
	      	key : '',
	      	message : ''
	      }
	  	},
	  	props:['token'],
	    methods: {
	    	closeModal(){
	    		this.$refs['modal-confirmation'].hide();
	    	},
	    	checkError(err){
		        const response = err.response;        
		        if(response.status == 401 && response.data.name == "Unauthorized"){
		                localStorage.removeItem("token");
		                localStorage.removeItem("member");
		                localStorage.removeItem("isFirstTime");
		                this.$router.push({ 
		                  path: '/login', 
		                });
		              }
		        else{
		          if(localStorage.getItem("token")){
		            var msg = (response.data)?response.data.message:err.message;
		            this.$notify({
					type: 'warn',
					text: msg
					})
		          }
		        }
		    }
	    },
	    mounted: function() {
	    	if(this.token){
	    		this.key = this.token;
	    	}

	    	if(this.key){
	    		Auth.confirmation({"verification-token":this.key}).then(response => {
		    		if(response.status == 200){
						this.$emit('token-verified');
		    			this.message = response.data.message;
		    			this.$refs['modal-confirmation'].show();
		    		}
		    	}).catch(err => {
		          this.checkError(err);
		        });
	    	}
	    }
  	}
</script>